// extracted by mini-css-extract-plugin
export var backgroundWrapper = "blogLayout-module--backgroundWrapper--47577";
export var body = "blogLayout-module--body--2bf94";
export var breadcrumbs = "blogLayout-module--breadcrumbs--089a5";
export var header = "blogLayout-module--header--bec2e";
export var headline = "blogLayout-module--headline--af897";
export var section = "blogLayout-module--section--b7953";
export var sectionHeadline = "blogLayout-module--sectionHeadline--5a0c3";
export var subscribeBanner = "blogLayout-module--subscribeBanner--48d8b";
export var titleCase = "blogLayout-module--titleCase--2e53e";
export var wrapper = "blogLayout-module--wrapper--45191";